import React from 'react';

class InternalLink extends React.Component {
    onClick = (e) => {
        e.preventDefault();

        const { onClick } = this.props;
        onClick(e);
    };

    render() {
        const { children, ...restProps } = this.props;

        return (
            <a {...restProps} onClick={this.onClick}>
                {children}
            </a>
        );
    }
}

InternalLink.defaultProps = {
    href: '#',
    onClick: () => {}
};

export default InternalLink;
